import Tooltip from '@mui/material/Tooltip/Tooltip';

export const BiggerTooltip = Tooltip;
